import { customersApi } from "@redux/features/customers/customersApi";
import { productsApi } from "@redux/features/products/productsApi";
import { useAppDispatch } from "@redux/hooks";
import { internalApiSlice, tags as internalApiTags } from "@redux/api/internalApiSlice";
import { DFS } from "@/types/general";
import { integrationsApi } from "@redux/features/integrations/integrationsApi";

const stockRelatedInvalidationTags = [
    { type: "Product" },
    { type: "Stock" },
    { type: "TotalInStock" },
    { type: "Restocking" },
    { type: "Picking" },
    { type: "BOM" },
    { type: "SaleOrder" }
];

// This object contains the tags that need to be invalidated for each module
const moduleInvalidationTags: { [key: string]: ({ type: string; id?: string; } | string)[] } = {
    "product": stockRelatedInvalidationTags,
    "stock": stockRelatedInvalidationTags,
    "customer": [{ type: "Customer" }],
    "stock_count": internalApiTags,
    poweroffice: [{ type: "Integrations", id: "LIST" }],
    tripletex: [{ type: "Integrations", id: "LIST" }],
    // Finago imports (including the customers/suppliers sync buttons) create and update customers and suppliers
    twenty_four_seven_office: [
        { type: "Integrations", id: "LIST" },
        { type: "Customer" },
        { type: "Supplier" },
    ],
    shopify: [{ type: "Integrations", id: "LIST" }],
    susoft: [{ type: "Integrations", id: "LIST" }],
};

export function invalidateModuleCache(
    moduleType: string,
    operation: DFS.Components.DataTransferOperations,
    dispatch: ReturnType<typeof useAppDispatch>
) {
    // Get the tags for the moduleType
    const tags = moduleInvalidationTags[moduleType];

    // Invalidate the tags for the moduleType
    switch (moduleType) {
        case "product":
            dispatch(productsApi.util.invalidateTags(tags));
            break;
        case "customer":
            dispatch(customersApi.util.invalidateTags(tags));
            break;
        case "stock_count":
            dispatch(internalApiSlice.util.invalidateTags(tags));
            break;
        case "stock":
            dispatch(internalApiSlice.util.invalidateTags(tags));
            break;
        case "product_draft":
            if (operation === "import") {
                dispatch(internalApiSlice.util.invalidateTags([{ type: "ProductDraft" }]));
                break;
            }

            if (operation === "export") {
                dispatch(
                    internalApiSlice.util.invalidateTags([
                        { type: "ProductDraft" },
                        { type: "Product" },
                    ])
                );
                break;
            }

            throw new Error(`Unsupported DFS operation [${operation}] for module [product_draft]`);
        case "poweroffice":
        case "tripletex":
        case "twenty_four_seven_office":
        case "shopify":
        case "susoft":
            dispatch(integrationsApi.util.invalidateTags(tags));
            break;
        default:
            break;
    }
}
